export { default } from "./PlusIcon";
